export default __webpack_public_path__ + "1e557c43ca1cb0f1fb78efcdfa3e97f5.png";